module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av426-cf4ce5ba9f098c9127b2a9535c18f90b.jpg";